export default __webpack_public_path__ + "static/media/Svenska-Blue.4412ac60.jpg";